<template>
  <div id="list">
    <div>
      <template v-if="type == 'staff' && team.team && team.team.representative">
        <span class="title">{{ $t("titles.tournament_representative") }}</span>

        <div
          class="representative"
          @click="openProfile(team.team.representative.id)"
        >
          <div class="item">
            <div class="label">{{ $t("params.name") }}</div>
            <div class="value">{{ team.team.representative.name }}</div>
          </div>

          <div class="item">
            <div class="label">{{ $t("params.surname") }}</div>
            <div class="value">{{ team.team.representative.surname }}</div>
          </div>

          <div class="item">
            <div class="label">{{ $t("params.phone") }}</div>
            <div class="value">{{ team.team.representative.phone }}</div>
          </div>

          <div class="item">
            <div class="label">{{ $t("params.email") }}</div>
            <div class="value">{{ team.team.representative.email }}</div>
          </div>
        </div>
      </template>

      <!-- <div v-if="type == 'players'" :class="[ team.team && parseInt(team.team.estimate_players) < parseInt(team.team.category.minimum_players) ? '':'hide', {'error':error.players}] " ref="estimation-body" class="estimate"> -->
      <div
        v-if="type == 'players'"
        :class="[
          estimate == null && estimate < estimate_minimum ? '' : 'hide',
          { error: error.players },
        ]"
        ref="estimation-body"
        class="estimate"
      >
        <template v-if="estimate == null">
          <template v-if="teamCategoryName != 'INTEGRA'">
            <div class="info">
              <p class="text">{{ $t("params.ask_estimated_players") }}</p>
              <!-- <span v-if="team.team" class="message_error">*{{$t('errors.estimate_players', {s : team.team.category.minimum_players})}}</span> -->
              <span
                class="message_error"
                v-html="$t('errors.estimate_players', { s: estimate_minimum })"
              ></span>
            </div>
            <div class="actions">
              <input
                class="value"
                type="number"
                min="1"
                v-model="input_estimate_players"
              />
              <!-- <button class="update-button" v-on:click="closeEstimation()">{{$t('cancel')}}</button> -->
              <button class="update-button" v-on:click="updateEstimate()">
                {{ $t("update") }}
              </button>
            </div>
          </template>
          <template v-else>
            <div class="info">
              <p class="text">
                {{ $t("params.ask_estimated_players") }}
              </p>
              <!-- <span v-if="team.team" class="message_error">*{{$t('errors.estimate_players', {s : team.team.category.minimum_players})}}</span> -->
              <span
                class="message_error"
                v-html="
                  $t('errors.estimate_players_maximum', { s: estimate_minimum })
                "
              ></span>
            </div>
            <div class="actions">
              <input
                class="value"
                type="number"
                min="1"
                v-model="input_estimate_players"
              />
              <!-- <button class="update-button" v-on:click="closeEstimation()">{{$t('cancel')}}</button> -->
              <button class="update-button" v-on:click="updateEstimate()">
                {{ $t("update") }}
              </button>
            </div>
          </template>
        </template>

        <template v-else>
          <div>
            <p class="text">{{ $t("descriptions.teams_zone_estimations") }}</p>
          </div>
        </template>
      </div>

      <!-- <div v-if="type == 'staff'" :class="[ team.team && parseInt(team.team.estimate_staff) <= 0 ? '':'hide', {'error':error.staff}] " ref="estimation-body" class="estimate"> -->
      <div
        v-if="type == 'staff'"
        :class="[
          estimate == null && estimate <= 0 ? '' : 'hide',
          { error: error.staff },
        ]"
        ref="estimation-body"
        class="estimate"
      >
        <template v-if="estimate == null">
          <template v-if="teamCategoryName != 'INTEGRA'">
            <div class="info">
              <p class="text">{{ $t("params.ask_estimated_staff") }}</p>
              <span
                class="message_error"
                v-html="$t('errors.estimate_staff')"
              ></span>
            </div>
            <div class="actions">
              <input
                class="value"
                type="number"
                min="1"
                v-model="input_estimate_staff"
              />
              <!-- <button class="update-button" v-on:click="closeEstimation()">{{$t('cancel')}}</button> -->
              <button class="update-button" v-on:click="updateEstimate()">
                {{ $t("update") }}
              </button>
            </div>
          </template>
          <template v-else>
            <div class="info">
              <p class="text">{{ $t("params.ask_estimated_staff") }}</p>
              <span
                class="message_error"
                v-html="$t('errors.estimate_staff_maximum')"
              ></span>
            </div>
            <div class="actions">
              <input
                class="value"
                type="number"
                min="1"
                v-model="input_estimate_staff"
              />
              <!-- <button class="update-button" v-on:click="closeEstimation()">{{$t('cancel')}}</button> -->
              <button class="update-button" v-on:click="updateEstimate()">
                {{ $t("update") }}
              </button>
            </div>
          </template>
        </template>

        <template v-else>
          <div>
            <p class="text">{{ $t("descriptions.teams_zone_estimations") }}</p>
          </div>
        </template>
      </div>

      <!-- <div v-if="type == 'acompanyants'" :class="[ team.team && team.team.estimate_acompanyants == null ? '' : 'hide', {'error':error.acompanyants}]" ref="estimation-body" class="estimate"> -->
      <div v-if="type == 'acompanyants'"
        :class="[estimate == null ? '' : 'hide', { error: error.acompanyants }]"
        ref="estimation-body"
        class="estimate"
      >
        <template v-if="estimate == null">
          <div class="info">
            <p class="text">{{ $t("params.ask_estimated_acompanyants") }}</p>
            <span
              class="message_error"
              v-html="$t('errors.estimate_acompanyants')"
            ></span>
          </div>
          <div class="actions">
            <input
              class="value"
              type="number"
              min="0"
              v-model="input_estimate_acompanyants"
            />
            <!-- <button class="update-button" v-on:click="closeEstimation()">{{$t('cancel')}}</button> -->
            <button class="update-button" v-on:click="updateEstimate()">
              {{ $t("update") }}
            </button>
          </div>
        </template>

        <template v-else>
          <div>
            <p class="text">{{ $t("descriptions.teams_zone_estimations") }}</p>
          </div>
        </template>
      </div>

      <div class="comptador">
        <!-- <div v-if="type == 'players' && team.team && team.team.estimate_players > 0" class="counter"> -->
        <div v-if="type == 'players' && estimate > 0" class="counter">
          <span class="count">{{ Object.keys(persons).length }}</span>
          <!-- <span class="total">/{{team.team.estimate_players}}</span> -->
          <span class="total">/{{ estimate }}</span>
        </div>

        <!-- <div v-if="type == 'staff' && team.team && team.team.estimate_staff > 0" class="counter"> -->
        <div v-if="type == 'staff' && estimate > 0" class="counter">
          <span class="count">{{ Object.keys(persons).length }}</span>
          <!-- <span class="total">/{{team.team.estimate_staff}}</span> -->
          <span class="total">/{{ estimate }}</span>
        </div>

        <!-- <div v-if="type == 'acompanyants' && team.team && team.team.estimate_acompanyants != null" class="counter"> -->
        <div v-if="type == 'acompanyants' && estimate != null" class="counter">
          <span class="count">{{ Object.keys(persons).length }}</span>
          <!-- <span class="total" v-if="team.team.input_estimate_acompanyants > 0">/{{team.team.estimate_acompanyants}}</span> -->
          <span class="total" v-if="estimate > 0">/{{ estimate }}</span>
        </div>

        <span class="page-title">{{ $t("titles." + type) }}</span>

        <!-- <span class="change-estimate" v-if="type == 'players'" v-show="team.team && parseInt(team.team.estimate_players) >= parseInt(team.team.category.minimum_players)" @click="openEstimation()" ref="estimation-title">{{$t('params.change_estimation')}}</span> -->
        <span
          class="change-estimate"
          v-if="type == 'players'"
          v-show="estimate != null"
          @click="openEstimation()"
          ref="estimation-title"
          >{{ $t("params.change_estimation") }}</span
        >

        <!-- <span class="change-estimate" v-if="type == 'staff'" v-show="team.team && parseInt(team.team.estimate_staff) > 0" @click="openEstimation()" ref="estimation-title">{{$t('params.change_estimation')}}</span> -->
        <span
          class="change-estimate"
          v-if="type == 'staff'"
          v-show="estimate != null"
          @click="openEstimation()"
          ref="estimation-title"
          >{{ $t("params.change_estimation") }}</span
        >

        <!-- <span class="change-estimate" v-if="type == 'acompanyants'" v-show="team.team && parseInt(team.team.estimate_acompanyants) >= 0" @click="openEstimation()" ref="estimation-title">{{$t('params.change_estimation')}}</span> -->
        <span
          class="change-estimate"
          v-if="type == 'acompanyants'"
          v-show="estimate != null"
          @click="openEstimation()"
          ref="estimation-title"
          >{{ $t("params.change_estimation") }}</span
        >
      </div>

      <div class="search">
        <div>
          <input
            type="text"
            v-model="search"
            :placeholder="$t('params.search')"
          />
        </div>
      </div>
    </div>

    <template v-if="type == 'players'">
      <v-data-table
        class="dataTable"
        id="players"
        :headers="playerHeaders"
        :items="persons"
        :search="search"
        :no-data-text="''"
        :no-results-text="''"
        :hideActions="true"
      >
        <template v-slot:items="props">
          <td @click="openProfile(props.item.id)">{{ props.item.dni }}</td>
          <td @click="openProfile(props.item.id)">{{ props.item.name }}</td>
          <td @click="openProfile(props.item.id)">{{ props.item.surname }}</td>
          <td @click="openProfile(props.item.id)">{{ props.item.birthday }}</td>
          <td @click="openProfile(props.item.id)">{{ props.item.number }}</td>
          <td class="edit">
            <img
              v-bind:src="'/img/edit-b.svg'"
              v-if="event.main_actions"
              alt="edit"
              @click="edit(props.item.id)"
            />
          </td>
          <td class="delete">
            <img
              v-bind:src="'/img/error.svg'"
              v-if="event.main_actions"
              alt="delete"
              @click="openDialog(props.item.id)"
            />
          </td>
        </template>
      </v-data-table>
    </template>

    <template v-else-if="type == 'sanctions'">
      <v-data-table
        class="dataTable sanctions"
        id="players"
        :headers="sanctionsHeaders"
        :items="persons"
        :search="search"
        :no-data-text="''"
        :no-results-text="''"
        :hideActions="true"
      >
        <template v-slot:items="props">
          <td><span class="status" :class="['s'+props.item.status]">{{ $t(props.item.status_sanction) }}</span></td>
          <td>{{ props.item.name }}</td>
          <td>{{ props.item.surname }}</td>
          <td>{{ $t(props.item.round_name) }}</td>
          <td>{{ props.item.num_match }}</td>
          <td>{{ props.item.matches_completed }}</td>
          <td>{{ props.item.type }}</td>
          <td>{{ $t("punishment." + props.item.type) }}</td>
        </template>
      </v-data-table>
    </template>

    <template v-else>
      <v-data-table
        class="dataTable"
        :headers="headers"
        :items="persons"
        :search="search"
        :no-data-text="''"
        :no-results-text="''"
        :hideActions="true"
      >
        <template v-slot:items="props">
          <td v-on:click="openProfile(props.item.id)">{{ props.item.dni }}</td>
          <td v-on:click="openProfile(props.item.id)">{{ props.item.name }}</td>
          <td v-on:click="openProfile(props.item.id)">
            {{ props.item.surname }}
          </td>
          <td v-on:click="openProfile(props.item.id)">
            {{ props.item.birthday }}
          </td>
          <td class="edit">
            <img
              v-bind:src="'/img/edit-b.svg'"
              v-if="event.main_actions"
              alt="edit"
              v-on:click="edit(props.item.id)"
            />
          </td>
          <td class="delete">
            <img
              v-bind:src="'/img/error.svg'"
              v-if="event.main_actions"
              alt="delete"
              v-on:click="openDialog(props.item.id)"
            />
          </td>
        </template>
      </v-data-table>
    </template>

    <ConfirmPopup
      @close="cancel()"
      @confirm="deleteConfirm()"
      :dialog="dialog"
    ></ConfirmPopup>
  </div>
</template>

<script>
import i18n from '@/i18n'
import ConfirmPopup from '@/components/ui/ConfirmPopup.vue'

export default {
  name: 'PersonList',
  props: {
    persons: {
      type: Array,
      required: true
    },
    type: {
      type: String,
      required: false,
      default: 'default' // adjust if there's a meaningful default
    },
    team: {
      type: Object,
      required: false,
      default: () => ({})
    },
    estimate: {
      type: Number,
      required: false,
      default: 0
    },
    estimate_minimum: {
      type: Number,
      required: false,
      default: 0
    }
  },
  components: {
    ConfirmPopup
  },
  data () {
    return {
      id: '',
      dialog: false,
      delete_confirm: false,
      search: '',
      input_estimate_players: '',
      input_estimate_staff: '',
      input_estimate_acompanyants: '',
      error: {
        players: false,
        staff: false,
        acompanyants: false
      }
    }
  },
  computed: {
    user () {
      return this.$store.getters['user/getUser']
    },

    teamCategoryName () {
      if (
        this.team &&
        this.team.team &&
        this.team.team.category &&
        this.team.team.category.name
      ) {
        return this.team.team.category.name
      }
      return ''
    },

    is_micfootball7 () {
      return (
        this.$store.getters.getCurrentEvent().name.toLowerCase() ===
        'micfootball7'
      )
    },

    event () {
      return this.$store.getters['getCurrentEvent']()
    },

    headers () {
      var aHeaders = [
        { text: i18n.t('params.dni'), value: 'dni', sortable: true },
        { text: i18n.t('params.name'), value: 'name', sortable: true },
        { text: i18n.t('params.surname'), value: 'surname', sortable: true },
        { text: i18n.t('params.birthday'), value: 'birthday', sortable: true }
      ]

      aHeaders.push({ text: i18n.t('edit'), sortable: false })
      aHeaders.push({ text: i18n.t('delete'), sortable: false })

      return aHeaders
    },

    playerHeaders () {
      var aHeaders = [
        { text: i18n.t('params.dni'), value: 'dni', sortable: true },
        { text: i18n.t('params.name'), value: 'name', sortable: true },
        { text: i18n.t('params.surname'), value: 'surname', sortable: true },
        { text: i18n.t('params.birthday'), value: 'birthday', sortable: true },
        {
          text: i18n.t('params.uniform_number'),
          value: 'number',
          sortable: true
        }
      ]

      aHeaders.push({ text: i18n.t('edit'), sortable: false })
      aHeaders.push({ text: i18n.t('delete'), sortable: false })

      return aHeaders
    },

    sanctionsHeaders () {
      var aHeaders = [
        { text: i18n.t('params.status'), value: 'status', sortable: true, width: '150px' },
        { text: i18n.t('params.name'), value: 'name', sortable: true, width: '150px' },
        { text: i18n.t('params.surname'), value: 'surname', sortable: true, width: '250px' },
        { text: i18n.t('miclive.standing.match'), value: 'round_name', sortable: true, width: '100px' },
        { text: i18n.t('params.num_matches'), value: 'num_match', sortable: true, width: '50px' },
        { text: i18n.t('params.num_matches_completed'), value: 'matches_completed', sortable: true, width: '50px' },
        { text: i18n.t('params.type'), value: 'type', sortable: true, width: '100px' },
        { text: i18n.t('params.sanction'), value: 'sanctions_name', sortable: true, width: '200px' }
      ]

      return aHeaders
    }
  },

  methods: {
    edit (id) {
      switch (this.type) {
        case 'players':
          this.$router
            .push({
              name: 'player_edit',
              params: {
                person_id: id
              }
            })
            .catch(() => {})
          break
        case 'staff':
          this.$router
            .push({
              name: 'staff_edit',
              params: {
                person_id: id
              }
            })
            .catch(() => {})
          break
        case 'acompanyants':
          this.$router
            .push({
              name: 'acompanyant_edit',
              params: {
                person_id: id
              }
            })
            .catch(() => {})
          break
        case 'responsables':
          this.$router
            .push({
              name: 'responsable_edit',
              params: {
                person_id: id
              }
            })
            .catch(() => {})
          break
      }
    },
    remove (id) {
      var self = this
      if (this.type === 'players') {
        this.$store
          .dispatch('person/removePlayer', {
            person_id: id
          })
          .then(function () {
            self.$emit('remove', id)
          })
      } else {
        this.$store
          .dispatch('person/removePerson', {
            person_id: id,
            team_id: this.team.team.id
          })
          .then(function () {
            self.$emit('remove', id)
          })
      }
    },
    openDialog (id) {
      // save person id
      this.id = id
      // open modal
      this.dialog = true
    },
    // open dialog
    deleteConfirm () {
      // close dialog
      this.dialog = false
      // delete person
      this.remove(this.id)
    },
    cancel () {
      // close dialog
      this.dialog = false
      // remove id
      this.id = ''
    },
    openProfile (id) {
      switch (this.type) {
        case 'players':
          this.$router
            .push({
              name: 'player',
              params: {
                person_id: id
              }
            })
            .catch(() => {})
          break
        case 'staff':
          this.$router
            .push({
              name: 'coach',
              params: {
                person_id: id
              }
            })
            .catch(() => {})
          break
        case 'acompanyants':
          this.$router
            .push({
              name: 'acompanyant',
              params: {
                person_id: id
              }
            })
            .catch(() => {})
          break
        case 'responsables':
          this.$router
            .push({
              name: 'responsable',
              params: {
                person_id: id
              }
            })
            .catch(() => {})
          break
      }
    },
    updateEstimate () {
      if (this.type === 'players') {
        this.handleEstimateUpdate(
          'players',
          this.input_estimate_players,
          this.estimate_minimum,
          this.isInvalidPlayerEstimate.bind(this)
        )
      }

      if (this.type === 'staff') {
        this.handleEstimateUpdate(
          'staff',
          this.input_estimate_staff,
          null,
          this.isInvalidStaffEstimate.bind(this)
        )
      }

      if (this.type === 'acompanyants') {
        this.handleEstimateUpdate(
          'acompanyants',
          this.input_estimate_acompanyants,
          null,
          this.isInvalidAcompanyantsEstimate.bind(this)
        )
      }
    },
    isInvalidPlayerEstimate (inputValue, min) {
      const val = parseInt(inputValue)
      const cat = this.team.team.category
      return (cat.name !== 'INTEGRA' && val < min) || (cat.name === 'INTEGRA' && val > min)
    },
    isInvalidStaffEstimate (inputValue) {
      const val = parseInt(inputValue)
      const cat = this.team.team.category
      return (cat.name !== 'INTEGRA' && val < 1) || (cat.name === 'INTEGRA' && val > 5)
    },
    isInvalidAcompanyantsEstimate (inputValue) {
      return parseInt(inputValue) < 0
    },
    handleEstimateUpdate (type, inputValue, minValue, isInvalidFn) {
      const self = this
      const teamData = this.team.team

      if (!teamData) return

      if (isInvalidFn(inputValue, minValue)) {
        this.error[type] = true
        return
      }

      this.error[type] = false

      const currentValue = teamData[`estimate_${type}`]
      if (currentValue === inputValue) {
        this.closeEstimation()
        return
      }

      const updatedInput = {
        estimate_players: type === 'players' ? inputValue : teamData.estimate_players,
        estimate_staff: type === 'staff' ? inputValue : teamData.estimate_staff,
        estimate_acompanyants: type === 'acompanyants' ? inputValue : teamData.estimate_acompanyants
      }

      this.$store
        .dispatch('team/updateEstimatePlayers', {
          team_id: teamData.id,
          input: updatedInput
        })
        .then(function () {
          self[`input_estimate_${type}`] = ''
          self.$emit('load')
          self.closeEstimation()

          if (!self.user.admin) {
            self.$store.dispatch('user/loadUser')
          }
        })
    },

    openEstimation () {
      this.$refs['estimation-body'].style.display = 'flex'
    },
    closeEstimation () {
      this.$refs['estimation-body'].style.display = 'none'
    }
  },
  watch: {
    type: function () {
      if (typeof this.$refs['estimation-body'] !== 'undefined') {
        switch (this.type) {
          case 'players':
            // if(this.team.team.estimate_players <= 0){
            if (this.estimate == null || this.estimate <= 0) {
              this.$refs['estimation-body'].style.display = 'flex'
            }
            break
          case 'staff':
            // if(this.team.team.estimate_staff <= 0){
            if (this.estimate == null || this.estimate <= 0) {
              this.$refs['estimation-body'].style.display = 'flex'
            }
            break
          case 'acompanyants':
            // if(this.team.team.estimate_acompanyants == null){
            if (this.estimate == null) {
              this.$refs['estimation-body'].style.display = 'flex'
            }
            break
        }
      }
    },
    team: function () {
      if (this.team.team) {
        this.input_estimate_players = this.team.team.estimate_players
        this.input_estimate_staff = this.team.team.estimate_staff
        this.input_estimate_acompanyants = this.team.team.estimate_acompanyants
      }
    }
  }
}
</script>

<style lang="scss" src="@/styles/_person_list.scss" scoped>
/* you can leave this empty or add component-specific overrides */
</style>
